import { Component, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SettingsService } from '@delon/theme';
import { Store } from '@ngrx/store';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-promo',
  templateUrl: './promo.component.html',
  styleUrls: ['./promo.component.less'],
  standalone: false
})
export class AppPromoComponent implements OnDestroy {
  @ViewChild('notification') notification!: TemplateRef<any>;

  isClicked: boolean = false;

  constructor(
    public settings: SettingsService,
    private notificationSrv: NzNotificationService,
    private router: Router,
    private store: Store<{ app: { isLocked: boolean } }>
  ) {}
  private destroy$ = new Subject<void>();

  ngOnDestroy(): void {
    this.showNotification();
    // this.destroy$.next();
    // this.destroy$.complete();
  }

  public showNotification() {
    // dont show notification after promo code is clicked
    if (!this.isClicked) {
      const ref = this.notificationSrv.template(this.notification, {
        nzPlacement: 'topRight',
        nzDuration: 0
      });
      this.store.select('app').subscribe(({ isLocked }) => {
        if (isLocked) {
          this.notificationSrv.remove(ref.messageId);
        }
      });
    }
  }

  useCoupon() {
    const company = this.settings.user['company'];
    if (company && company.isOwner && !company.isSample) {
      this.isClicked = true;
      this.router.navigate(
        [`account/subscription/subscribe/${company.tenantId}`],
        {
          queryParams: {
            promo: 'QNE1stAI'
          }
        }
      );
    }
  }
}
